import React, { useRef } from "react";
import "./Educations.css";
import "../../components/timeline/Timeline.css";
import DegreeCard from "../../components/degreeCard/DegreeCard.js";
import useTimeline from "../../components/timeline/useTimeline";
import Reveal from "../../components/reveal/Reveal";
import { degrees } from "../../portfolio";

export default function Educations() {
  const root = useRef(null);
  useTimeline(root, []);
  return (
    <section className="main edu-section" id="educations" ref={root}>
      <Reveal>
        <div className="section-head">
          <span className="section-kicker">Degree</span>
          <h2 className="section-title sm">Degrees received</h2>
        </div>
      </Reveal>
      <div className="tl">
        <div className="tl-line" aria-hidden="true" />
        <div className="tl-progress" aria-hidden="true" />
        <ul className="tl-list">
          {degrees.degrees.map((degree) => (
            <li className="tl-item" key={degree.title}>
              <span className="tl-node" aria-hidden="true" />
              <DegreeCard degree={degree} />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
